<template>
  <div>
    <div class="row-1">
      <div class="section-field">
        <label> Comprimento </label>
        <!-- <input v-maska="['#.###', '']" class="field p-3" v-model="dados.Comprimento" placeholder="mm"  > -->
        <input
          v-model="v$.dados.Comprimento.$model"
          v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']"
          placeholder="Medida em mm"
          :class="['field', { error: v$.dados.Comprimento.$error }]"
          :disabled="configInputs"
        />

        <div class="text-red" v-if="v$.dados.Comprimento.$error">
          O campo Comprimento é obrigatório.
        </div>
      </div>

      <div class="section-field">
        <label> Largura </label>
        <input
          min="0"
          v-model="v$.dados.Largura.$model"
          v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']"
          placeholder="Medida em mm"
          :class="['field', { error: v$.dados.Largura.$error }]"
          :disabled="configInputs"
        />

        <div class="text-red" v-if="v$.dados.Largura.$error">
          O campo Largura é obrigatório.
        </div>
      </div>

      <div class="section-field">
        <label> Altura </label>
        <input
          min="0"
          v-model="v$.dados.Altura.$model"
          v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']"
          placeholder="Medida em mm"
          :class="['field', { error: v$.dados.Altura.$error }]"
          :disabled="configInputs"
        />
        <div class="text-red" v-if="v$.dados.Altura.$error">
          O campo Altura é obrigatório.
        </div>
      </div>

      <div class="section-field">
        <label> Peso Aproximado </label>
        <input
          min="0"
          v-model="v$.dados.Peso_Aproximado.$model"
          v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']"
          placeholder="Medida em Kg"
          :class="['field', { error: v$.dados.Peso_Aproximado.$error }]"
          :disabled="configInputs"
        />
        <div class="text-red" v-if="v$.dados.Peso_Aproximado.$error">
          O campo Peso Aproximado é obrigatório.
        </div>
      </div>
      <div class="section-field">
        <label> Anel de Centragem </label>
        <input
          min="0"
          v-model="v$.dados.Anel_de_Centragem.$model"
          v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']"
          placeholder="Medida em mm"
          :class="['field', { error: v$.dados.Anel_de_Centragem.$error }]"
          :disabled="configInputs"
        />
        <div class="text-red" v-if="v$.dados.Anel_de_Centragem.$error">
          O campo Anel de Centragem é obrigatório.
        </div>
      </div>

      <div class="section-field">
        <label> Formato da Bucha </label>
        <div style="display: flex; gap: 2rem">
          <div class="input_radio">
            <input
              type="radio"
              v-model="v$.dados.Raio.$model"
              :class="[{ error: v$.dados.Raio.$error }]"
              :disabled="configInputs"
              id="raio"
              value="raio"
            />
            <label for="raio">Raio</label>
          </div>

          <div class="input_radio">
            <input
              type="radio"
              v-model="v$.dados.Raio.$model"
              :class="[{ error: v$.dados.Raio.$error }]"
              :disabled="configInputs"
              id="angulo"
              value="angulo"
            />
            <label for="angulo">Ângulo 45°</label>
          </div>
        </div>
        <div class="text-red" v-if="v$.dados.Raio.$error">
          O campo Raio é obrigatório.
        </div>
      </div>

      <div class="section-field">
        <label> Refrigeração do Lado Movel </label>
        <input
          v-maska="['##/##', '']"
          class="field"
          v-model="dados.Refrigeracao"
          placeholder="Entrada / Saída"
          :disabled="configInputs"
        />
      </div>
      <div class="section-field">
        <label> Refrigeraçãodo Lado Fixo </label>
        <input
          min="0"
          v-model="dados.LadoFixo"
          v-maska="['##/##', '']"
          placeholder="Entrada / Saída"
          class="field"
          :disabled="configInputs"
        />
      </div>

      <div class="section-field">
        <label>Refrigeração de Gavetas </label>
        <input
          min="0"
          v-model="dados.Gavetas"
          v-maska="['##/##', '']"
          placeholder="Entrada / Saída"
          class="field"
          :disabled="configInputs"
        />
      </div>

      <div>
        <div class="section-field" v-if="configInputs == 0">
          <label class="">Tipos de Moldes </label>
          <select
            v-model="v$.dados.opcao_tipo_molde.$model"
            class="field_select"
          >
            <option value="" disabled selected>Selecione a opção</option>
            <option :value="2">2 Placas</option>
            <option :value="3">3 Placas</option>
          </select>
        </div>
        <div class="section-field" v-else-if="configInputs == 1">
          <label class="">Tipos de Moldes </label>
          <select
            disabled
            v-model="v$.dados.opcao_tipo_molde.$model"
            class="field_select"
          >
            <option v-if="dados.opcao_tipo_molde === 2" :value="2">
              2 Placas
            </option>
            <option v-else-if="dados.opcao_tipo_molde === 3" :value="3">
              3 Placas
            </option>
          </select>
        </div>
        <div class="section-field" v-else>
          <label class="">Tipos de Moldes </label>
          <select
            v-model="v$.dados.opcao_tipo_molde.$model"
            class="field_select"
          >
            <option value="" disabled selected>Selecione a opção</option>
            <option :value="2">2 Placas</option>
            <option :value="3">3 Placas</option>
          </select>
        </div>
      </div>

      <div>
        <div class="section-field" v-if="configInputs == 0">
          <label class=""> Sistema de Extração </label>
          <select
            v-model="sistemaDeExtracaoOpcao"
            class="field_select"
            @change="updateSelectionSistemaExtracao"
          >
            <option value="" disabled selected>Selecione uma opção</option>
            <option value="1">Hidráulico</option>
            <option value="2">Pneumático</option>
            <option value="3">Mecânico</option>
          </select>
        </div>

        <div class="section-field" v-else-if="configInputs == 1">
          <label class=""> Sistema de Extração </label>
          <select disabled class="field_select">
            <option v-if="dados.watHidra === 'true'" :value="1">
              Hidráulico
            </option>
            <option v-else-if="dados.watPne === 'true'" :value="2">
              Pneumático
            </option>
            <option v-else-if="dados.watMec === 'true'" :value="3">
              Mecânico
            </option>
            <option v-else value="">Não informado</option>
          </select>
        </div>
        <div class="section-field" v-else>
          <label class=""> Sistema de Extração </label>
          <select
            v-model="sistemaDeExtracaoOpcao"
            class="field_select"
            @change="updateSelectionSistemaExtracao"
          >
            <option value="" disabled selected>Selecione uma opção</option>
            <option value="1">Hidráulico</option>
            <option value="2">Pneumático</option>
            <option value="3">Mecânico</option>
          </select>
        </div>
      </div>

      <div class="section-field">
        <label class=""> Curso Extrator </label>
        <input
          min="0"
          :disabled="configInputs"
          v-model="v$.dados.cursor_extrator.$model"
          v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']"
          placeholder="Medida em mm"
          :class="['field', { error: v$.dados.cursor_extrator.$error }]"
        />
        <div class="text-red" v-if="v$.dados.cursor_extrator.$error">
          O campo Curso Extrator é obrigatório.
        </div>
      </div>
      <div>
        <div class="section-field" v-if="configInputs == 0">
          <label class=""> Possui Câmara Quente ? </label>
          <select
            v-model="dados.camera_quente.showCameraQuente"
            class="field_select"
          >
            <option value="" disabled selected>Selecione a opção</option>
            <option :value="true" @click="camara = true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>
        <div class="section-field" v-else-if="configInputs == 1">
          <label class=""> Possui Câmara Quente ? </label>
          <select disabled class="field_select">
            <option v-if="dados.camera_quente.showCameraQuente === true">
              Sim
            </option>
            <option v-else-if="dados.camera_quente.showCameraQuente === false">
              Não
            </option>
          </select>
        </div>
        <div class="section-field" v-else>
          <label class=""> Possui Câmara Quente ? </label>
          <select
            v-model="dados.camera_quente.showCameraQuente"
            class="field_select"
          >
            <option value="" disabled selected>Selecione a opção</option>
            <option :value="true" @click="camara = true">Sim</option>
            <option :value="false">Não</option>
          </select>
        </div>
      </div>
    </div>
    <div>
      <div v-show="dados.camera_quente.showCameraQuente">
        <div>
          <div class="main-cq">
            <h3>Câmara Quente</h3>

            <div class="row-1">
              <div class="section-field">
                <label class=""> ID </label>
                <input
                  :disabled="configInputs"
                  v-model="dados.camera_quente.id"
                  type="text"
                  class="field"
                />
              </div>

              <div class="section-field">
                <label class=""> Número de Zonas </label>
                <input
                  :disabled="configInputs"
                  v-model="dados.camera_quente.n_zonas"
                  v-maska="['###', '']"
                  class="field"
                />
              </div>

              <div class="section-field">
                <label class=""> Fabricante </label>
                <input
                  :disabled="configInputs"
                  v-model="dados.camera_quente.fabricante"
                  type="text"
                  class="field"
                />
              </div>

              <div class="section-field">
                <label class=""> Tipo Termopar </label>
                <input
                  :disabled="configInputs"
                  v-model="dados.camera_quente.tipo_termopar"
                  type="text"
                  class="field"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div>
        <div>
          <label class=""> Comentários Molde Fechado: </label>
          <textarea
            v-model="dados.comentario"
            class="field_text"
            rows="5"
            cols="50"
            maxlength="500"
            :disabled="configInputs"
            :placeholder="
              configInputs == 0
                ? 'Escreva com no máximo 500 caracteres'
                : 'Nenhum comentário adicionado'
            "
            style="resize: none; color: var(--font_color)"
          >
          </textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputPersonMM from "../../../../../Inputs-defaults/Inp-Person-1.vue";
import Input_1 from "../../../../../Inputs-defaults/Inp-1.vue";
import InputRadios from "../../../../../Inputs-defaults/Inp-radius-emit .vue";
import InputCheckbox from "../../../../../Inputs-defaults/Inp-checkbox-emit .vue";
import InputSelect from "../../../../../Inputs-defaults/Inp-Select-emit.vue";
import ChecklistSlot from "../../../../../Tables/ChecklistSlot.vue";
import useVuelidate from "@vuelidate/core";
import {
  required,
  minLength,
  minValue,
  numeric,
  between,
} from "@vuelidate/validators";
import { GetDataAllLayout } from "../../../../../../controllers/LayoutExtrcao/GetDataAllLayout";
export default {
  components: {
    InputPersonMM,
    Input_1,
    InputRadios,
    InputCheckbox,
    InputSelect,
    ChecklistSlot,
  },
  props: {
    configInputs: Number,
  },
  async created() {
    const resp = await GetDataAllLayout();
    if (resp != undefined) {
      this.lista = resp.data.list;
    }
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      sistemaDeExtracaoOpcao: "",
      camara: false,
      sisextra: Object,
      tipomolde: Number,
      opcao: Boolean,
      opcao_cq: false,
      showCameraQuente: false,
      watHidra: Boolean,
      watPne: Boolean,
      watMec: Boolean,
      lista: [],

      dados: {
        Comprimento: "",
        Largura: "",
        Altura: "",
        Peso_Aproximado: "",
        Anel_de_Centragem: "",
        Raio: "",
        Refrigeracao: "",
        LadoFixo: "",
        Gavetas: "",
        opcao_tipo_molde: "", //"Number"
        watHidra: false,
        watPne: false,
        watMec: false,
        camera_quente: {
          showCameraQuente: false,
          id: "",
          n_zonas: "",
          fabricante: "",
          tipo_termopar: "",
        },
        checklist: Object,
        comentario: "",
      },
    };
  },
  validations() {
    return {
      dados: {
        Comprimento: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Largura: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Altura: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Peso_Aproximado: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Anel_de_Centragem: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Raio: {
          required,
        },
        opcao_tipo_molde: {
          required,
          betweenValue: between(2, 3),
        },
        cursor_extrator: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
      },
    };
  },

  methods: {
    preview() {
      const id = this.dados.layout_extracao;

      const lista = this.lista.find((element) => element.ID === id);
      this.$swal.fire({
        imageUrl:
          `${this.$store.state.ImgURL}layout_extracao/` +
          `${lista.PATH_LAYOUT}`,
        imageWidth: 700,
        imageHeight: 400,
        imageAlt: "Custom image",
      });
    },
    getObjExt(payload) {
      this.sisextra = payload;
    },
    getRaioSelect(payload) {
      this.tipomolde = payload;
    },

    getRaioShowCQ(payload) {
      if (payload == "true") {
        this.showCameraQuente = true;
      } else {
        this.showCameraQuente = false;
      }
    },
    async getDataChecklist(payload) {
      this.dados.checklist = payload;
    },

    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.MoldeFechado) {
        this.dados.Comprimento = dataQuery.MoldeFechado[0].COMPRIMENTO_MOLDE;
        this.dados.Largura = dataQuery.MoldeFechado[0].LARGURA_MOLDE;
        this.dados.Altura = dataQuery.MoldeFechado[0].ALTURA_MOLDE;
        this.dados.Peso_Aproximado = dataQuery.MoldeFechado[0].PESO_MOLDE;
        this.dados.Anel_de_Centragem = dataQuery.MoldeFechado[0].ANEL_CENTRAGEM;
        this.dados.Bucha_de_Injecao =
          dataQuery.MoldeFechado[0].BUCHA_DE_INJECAO;
        this.dados.Raio = dataQuery.MoldeFechado[0].RAIO_MOLDE;
        this.dados.Refrigeracao = dataQuery.MoldeFechado[0].REFRIGERACAO;
        this.dados.LadoFixo = dataQuery.MoldeFechado[0].LADO_FIXO;
        this.dados.Gavetas = dataQuery.MoldeFechado[0].GAVETAS;
        this.dados.opcao_tipo_molde = dataQuery.MoldeFechado[0].TIPO_DE_MOLDE;
        this.dados.watHidra = dataQuery.MoldeFechado[0].SISTEMA_DE_EXTRACAO_HID;
        this.dados.watPne = dataQuery.MoldeFechado[0].SISTEMA_DE_EXTRACAO_PNE;
        this.dados.watMec = dataQuery.MoldeFechado[0].SISTEMA_DE_EXTRACAO_MEC;
        if (this.dados.watHidra == "true") this.sistemaDeExtracaoOpcao = "1";
        else if (this.dados.watPne == "true") this.sistemaDeExtracaoOpcao = "2";
        else if (this.dados.watMec == "true") this.sistemaDeExtracaoOpcao = "3";
        else this.sistemaDeExtracaoOpcao = "none";
        this.dados.cursor_extrator = dataQuery.MoldeFechado[0].CURSOR_EXTRATOR;
        this.dados.layout_extracao = dataQuery.MoldeFechado[0].ID_LAYOUT;
        this.dados.distancia_furos = dataQuery.MoldeFechado[0].DIST_FUROS;
        this.dados.diametro = dataQuery.MoldeFechado[0].DIAMETRO;
        this.dados.camera_quente.showCameraQuente = JSON.parse(
          dataQuery.MoldeFechado[0].CAMARA_QUENTE
        );
        this.dados.camera_quente.id = dataQuery.MoldeFechado[0].CQ_ID;
        this.dados.camera_quente.n_zonas = dataQuery.MoldeFechado[0].CQ_N_ZONAS;
        this.dados.camera_quente.fabricante =
          dataQuery.MoldeFechado[0].CQ_FABRICANTE;
        this.dados.camera_quente.tipo_termopar =
          dataQuery.MoldeFechado[0].CQ_TIPO_TERMOPAR;
        this.dados.comentario = dataQuery.MoldeFechado[0].COMENTARIO;
      }
    },
    updateSelectionSistemaExtracao() {
      this.dados.watHidra = false;
      this.dados.watPne = false;
      this.dados.watMec = false;
      if (this.sistemaDeExtracaoOpcao === "1") {
        this.dados.watHidra = true;
      } else if (this.sistemaDeExtracaoOpcao === "2") {
        this.dados.watPne = true;
      } else if (this.sistemaDeExtracaoOpcao === "3") {
        this.dados.watMec = true;
      }
    },
  },

  watch: {
    "dados.camera_quente.showCameraQuente"(newVal) {
      this.camara = newVal;
      this.$emit("dataCamara", newVal);
    },
    // camara(newValue) {
    //   this.$emit("dataCamara", newValue)

    // },
    dados: {
      deep: true, // detectar mudanças aninhadas em objetos
      immediate: true, // acionando o manipulador imediatamente com o valor atual
      handler(newValue, oldValue) {
        console.log(newValue);

        this.$emit("dataMoldeFechado", newValue);
      },
    },
  },
};
</script>

<style scoped>
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.input_radio {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.main-cq {
  opacity: 0;
  animation: fadeIn 1s ease forwards !important;
}

.main-cq h3 {
  padding-bottom: 0.5rem;
}

.field:focus {
  border: 1px solid var(--green) !important;
}

.field:hover {
  border: 1px solid var(--input_hover) !important;
  transition: border-color 0.5s ease;
}

.field::placeholder {
  color: rgb(65, 62, 62) !important;
}

.row-1 {
  gap: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  color: var(--font_color);
  margin-bottom: 0.5rem;
}

.row-2 {
  gap: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  color: var(--font_color);
  margin-bottom: 0.5rem;
}

label {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}

.field {
  border-radius: 10px !important;
  border: 2px solid #d9d9d9 !important;
  height: 2.5rem !important;
  width: 13rem !important;
  padding: 1rem;
  color: var(--font_color);
  cursor: text;
}

.field_text {
  width: 100% !important;
  border-radius: 10px !important;
  border: 1px solid #d9d9d9;
  height: 5rem !important;
  padding: 0.5rem;
  color: var(--font_color);
}

.field_text:focus {
  border: 1px solid var(--green) !important;
  transition: border-color 0.5s ease;
}

.field_select {
  border-radius: 10px !important;
  border: 2px solid #d9d9d9;
  height: 2.5rem !important;
  width: 13rem !important;
  color: var(--font_color);
  padding-left: 1.2rem;
  cursor: text;
}

.field_select2 {
  border-radius: 10px !important;
  border: 2px solid #d9d9d9;
  height: 2.5rem !important;
  width: 13rem !important;
  color: var(--font_color);
  padding-left: 16px;
}

.section_field {
  display: flex;
  flex-direction: column;
  gap: 0rem;
}

.section_field option {
  color: var(--font_color);
  background-color: #f0f0f0;
  border-radius: 5rem !important;
}

.section_field option:hover {
  background-color: #e0e0e0 !important;
}

.section_field option:checked {
  background-color: var(--font_color);
  border-radius: 5rem !important;
  color: white !important;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.275rem 0.4rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  /* color: #212529; */
  text-align: center;
  white-space: nowrap;
  color: var(--white);
  background-color: var(--green);
  /* border: 1px solid #ced4da; */
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-right: 1px solid var(--greyBtn);
  border-bottom: 1px solid var(--greyBtn);
  border-top: 1px solid var(--greyBtn);
  border-left: none;
}

.flex-row {
  display: flex;
}

.flex {
  flex-direction: column;
}

.text-red {
  color: var(--redTransparent);
  font-size: 12px;
  margin-top: 2px;
}

.error:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--red);
  outline: 0;
}

.error {
  border-radius: 10px !important;
  padding: 1rem;
  color: var(--font_color);
  border: 1px solid red !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: red;
  font-size: 0.8rem;
  width: 13rem !important;
  text-align: center !important;
}

h3 {
  font-size: 0.85rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}

.section-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

@media (max-width: 1266px) {
  .row-1,
  .row-2 {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    width: 100% !important;
  }

  .section-field {
    width: 100%;
  }

  .field {
    width: 100%;
  }
}

@media (max-width: 1205px) {
  .row-1,
  .row-2 {
    grid-template-columns: 1fr 1fr 1fr;
    width: 100% !important;
  }
  .section-field {
    width: 15rem;
  }

  .field,
  .field_select {
    width: 100% !important;
  }
}

@media (max-width: 983px) {
  .row-1,
  .row-2 {
    grid-template-columns: 1fr 1fr;
    width: 100% !important;
  }

  .section-field {
    width: 18rem;
  }

  .field,
  .field_select {
    width: 100% !important;
  }
}

@media (max-width: 743px) {
  .section-field {
    width: 15rem;
  }

  .field,
  .field_select {
    width: 100% !important;
  }
}

@media (max-width: 638px) {
  .row-1,
  .row-2 {
    grid-template-columns: 1fr;
    width: 100% !important;
  }

  .section-field {
    width: 100% !important;
  }
}
</style>
